import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-marchi',
  templateUrl: './marchi.component.html',
  styleUrls: ['./marchi.component.css']
})
export class MarchiComponent implements OnInit {

  constructor(
    
  ) { }

  ngOnInit() {
    
  }

}
